export default {
  route: {
    dashboard: 'Dashboard',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    i18n: 'I18n',
    storeInfo: 'Store Info',
    shopProduct: 'Shop Product',
    account: 'Account',
    reservation: 'Reservation',
    reservationOrder: 'Reservation Order',
    orderTrack: 'Order Track',
    orderDetail: 'Order Detail',
    orderRecord: 'Order Record',
    editOrder: 'Edit Order',
    createOrder: 'Create Order',
    orderEvaluation: 'Order Evaluation',
    productManagement: 'Product Management',
    productCategory: 'Product Category',
    skuManagement: 'Sku Management',
    serviceManagement: 'Service Management',
    performanceMethod: 'Performance Method',
    promotionManagement: 'Promotion Management',
    orderReduction: 'Order Reduction',
    partner: 'Partner',
    serviceMall: 'Service Mall',
    orderManagement: 'Order Management',
    mallAddCountry: 'Add Country',
    activity: 'Activity',
    activityList: 'Activity List',
    uploadImage: 'Upload Image',
    productList: 'Product List'
  },
  navbar: {
    dashboard: 'Dashboard',
    github: 'Github',
    logOut: 'Log Out',
    profile: 'Profile',
    theme: 'Theme',
    size: 'Global Size'
  },
  login: {
    title: 'Business management',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  permission: {
    addRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    importance: 'Imp',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    import: 'Import',
    importPic: 'Import Picture',
    reviewer: 'reviewer',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    on: 'On',
    off: 'Off',
    enable: 'Enable',
    abolish: 'Abolish',
    modify: 'Modify'
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name (default excel-list)'
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    tagsView: 'Open Tags-View',
    fixedHeader: 'Fixed Header',
    sidebarLogo: 'Sidebar Logo'
  },
  shopInfo: {
    country: 'Country',
    state: 'State',
    city: 'City',
    partnerCode: 'Partner Code',
    partnerName: 'Partner Name',
    partnerPhone: 'Partner Phone',
    storeCode: 'Store Code',
    storeType: 'Store Type',
    storeName: 'Store Name',
    address: 'Address',
    lI: 'L&I',
    phone: 'Phone',
    ownerName: 'Owner Name',
    workTime: 'Working Time',
    rate: 'Rate',
    level: 'Level',
    restDate: 'Rest Date',
    import: 'import',
    aspCode: 'ASP Code',
    brand: 'Brand',
    status: 'Status',
    reserve: 'Reserve'
  },
  shopProduct: {
    partnerCode: 'Partner Code',
    storeCode: 'Store Code',
    storeName: 'Store Name',
    service: 'Service',
    product: 'Product',
    performance: 'Performance',
    status: 'status',
    configure: 'configure',
    all: 'All',
    clear: 'clear',
    firstClass: 'First Classification',
    secondClass: 'Second Classification',
    thirdClass: 'Third Classification',
    quality: 'Quality',
    brandModel: 'Brand&Model',
    brand: 'Brand',
    model: 'Model',
    productCode: 'Product Code',
    productName: 'Product Name',
    price: 'Price'
  },
  shopAccount: {
    owner: 'Owner',
    phone: 'Phone',
    partnerCode: 'Partner Code',
    storeCode: 'Store Code',
    account: 'Account',
    password: 'Password',
    add: 'Add'
  },
  order: {
    source: 'Source',
    channel: 'Channel',
    account: 'Account',
    country: 'Country',
    orderNumber: 'Order Number',
    storeCode: 'Store Code',
    resDate: 'Reservation Date',
    time: 'Time',
    customerName: 'Customer Name',
    phone: 'Phone Number',
    status: 'Status',
    contact: 'Contact',
    evaluation: 'Evaluation',
    add: 'Add',
    createTime: 'Create Time',
    serviceStore: 'Service Store',
    model: 'Device Model',
    des: 'Fault Description',
    remark: 'Remark',
    latestTime: 'Latest DS Time',
    dsResult: 'DS Result',
    detail: 'Details',
    cancel: 'Cancel',
    acceptionTime: 'Acception Time',
    receptionTime: 'Reception Time',
    callCode: 'Call Code',
    repairedPhone: 'Repaired Phone',
    faultAnalysis: 'Fault Analysis',
    serviceDetails: 'Service Details',
    serviceType: 'Service Type',
    price: 'Price',
    discount: 'Discount',
    payment: 'Payment',
    finishTime: 'Finish Time',
    pickUpTime: 'Pick-up TIme',
    feedbackTime: 'Feedback Time',
    enviroment: 'Enviroment',
    attitude: 'Attitude',
    efficiency: 'Efficiency',
    repairQuality: 'Repair Quality',
    serviceScore: 'Service Score',
    serviceEvaluation: 'Service Evaluation',
    submit: 'Submit',
    choose: 'Choose',
    record: 'Record',
    productType: 'Product Type',
    quality: 'Quality',
    deviceModel: 'Device Model',
    productFeatures: 'Product Features',
    type: 'Type',
    applicableModel: 'Applicable Model',
    productCode: 'Product Code',
    color: 'Color',
    productName: 'Product Name',
    specification: 'Specification',
    serviceLevel: 'Service Level',
    serviceMothod: 'Service Mothod',
    servcieStore: 'Servcie Store',
    reservationTime: 'Reservation Time',
    phoneNumber: 'Phone Number',
    customerRemark: 'Customer Remark',
    paymentMethod: 'Payment Method',
    payStatus: 'Pay Status'
  },
  productCategory: {
    firstClass: 'First Classification',
    firstClassCode: 'First Classification Code',
    secondClass: 'Second Classification',
    secondClassCode: 'Second Classification Code',
    thirdClass: 'Third Classification',
    thirdClassCode: 'Third Classification Code'
  },
  skuManagement: {
    spec: 'Product Specifications',
    businessType: 'Business Type',
    remarks: 'Remark',
    price: 'Material Price',
    prodCode: 'Material Code',
    prodName: 'Material Name',
    brand: 'Brand',
    model: 'Model',
    color: 'Color',
    appBrand: 'Applicable Brand',
    appModel: 'Applicable Model',
    prodFeatures: 'Product Features'
  },
  serviceManagement: {
    price: 'Service Price',
    prodCode: 'Service Code',
    prodName: 'Service Name',
    serviceLevel: 'Level'
  },
  performanceMethod: {
    price: 'Method Price',
    prodCode: 'Method Code',
    prodName: 'Method Name'
  },
  prodManage: {
    material: 'Material',
    service: 'Service',
    performanceMethod: 'Performance Method',
    picture: 'Picture',
    desc: 'Description',
    detail: 'Detail',
    disPrice: 'Discount Price',
    inventory: 'Inventory'
  },
  orderReduction: {
    promoteName: 'Promotion Plan',
    deductAmount: 'Deduction Amount',
    validTime: 'Valid Time',
    promoteRange: 'Range',
    priority: 'Priority',
    overlay: 'Overlay',
    operator: 'Operator',
    createTime: 'Create Time',
    updateTime: 'Update Time'
  },
  orderEvaluation: {
    show: 'Show',
    hide: 'Hide',
    account: 'Account',
    orderNumber: 'Order Number',
    servcieStore: 'Service Store',
    customerName: 'Customer Name',
    phoneNumber: 'Phone Number',
    feedbackTime: 'Feedback Time',
    enviroment: 'Enviroment',
    attitude: 'Attitude',
    efficiency: 'Efficiency',
    repairQuality: 'Repair Quality',
    serviceEvaluation: 'Service Evaluation',
    startDate: 'Start Date',
    endDate: 'End Date'
  },
  promoteManage: {
    title: 'Title',
    banner: 'Banner',
    url: 'URL',
    product: 'Product',
    prodName: 'Product Name',
    detail: 'Detail',
    condition: 'Condition',
    excPrice: 'Exclusive Price',
    activityUrl: 'Activity Url'
  }
};